import { getExitLoopTarget } from 'pages/AutomationEngine/store/ts-utilities';
import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

// `Exit <variable name> Loop`. The step carries the loops enclosing it,
// innermost first, so the name comes from whichever of them it exits - the
// innermost when it holds no reference of its own.
export const getDescription = ({ step, t }) => {
  const loop = getExitLoopTarget(step);

  if (!loop) {
    return `${t('Exit Loop')} ${t('[Deleted]')}`;
  }

  return t('Exit {{ variableName }} Loop', {
    variableName: loop.variableName,
  });
};

export default function ExitLoopCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
